// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oxznr","col":"styles_col__gRFiQ"};